import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonConstant} from '../../../app.constants';
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'measure-pdf-export',
  templateUrl: './measure-pdf-export.component.html',
  styleUrls: ['./measure-pdf-export.component.scss']
})
export class MeasurePdfExportComponent {

  @Input() maxPagePostEngagement: number;
  @Input() maxPageRoi: number;
  @Input() maxPageInteraction: number;

  @Output() closeEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() exportPDFEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() exportCSVEvent: EventEmitter<any> = new EventEmitter<any>();

  public selectedPagePostEngagement;
  public selectedPageRoi;
  public selectedPageInteraction;

  public isSelectedPostCount = false;

  constructor(private userService: UserService) {

  }

  close() {
    this.isSelectedPostCount = false;
    this.closeEvent.emit();
  }

  onChangePostEngagementPage(evt) {
    this.selectedPagePostEngagement = evt;
  }

  onChangeRoiPage(evt) {
    this.selectedPageRoi = evt;
  }

  onChangeInteractionPage(evt) {
    this.selectedPageInteraction = evt;
  }

  exportCSV() {
    this.exportCSVEvent.emit();
  }

  exportPdf() {
    if (!this.isSelectedPostCount && (this.maxPageInteraction || this.maxPageRoi || this.maxPagePostEngagement)) {
      this.isSelectedPostCount = true;
      return;
    }
    if (!this.selectedPagePostEngagement) {
      this.selectedPagePostEngagement = Math.min(this.maxPagePostEngagement, CommonConstant.MAX_ITEM_PER_PAGE_REPORT);
    }
    if (!this.selectedPageRoi) {
      this.selectedPageRoi = Math.min(this.maxPageRoi, CommonConstant.MAX_ITEM_PER_PAGE_REPORT);
    }
    if (!this.selectedPageInteraction) {
      this.selectedPageInteraction = Math.min(this.maxPageInteraction, CommonConstant.MAX_ITEM_PER_PAGE_REPORT);
    }
    this.exportPDFEvent.emit({
      postEngagementPage: this.selectedPagePostEngagement,
      roiPage: this.selectedPageRoi,
      interactionPage: this.selectedPageInteraction
    });
    // close popup
    this.close();
  }

  get canSelectPostPage() {
    return this.isSelectedPostCount && (this.maxPageInteraction || this.maxPageRoi || this.maxPagePostEngagement);
  }

  get canExportCsv() {
    return this.userService.isEnterpriseAccount() || this.userService.isPremiumAccount();
  }

}



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-pdf-export/measure-pdf-export.component.ts